import { sizeProps } from "#ce/composables/useSize";

export const props = Object.freeze({
  ...sizeProps,
  /**
   * Name of the icon from the design system's sprite (resolved against the per-client icon manifest).
   *
   * @type {String}
   * @default undefined
   */
  name: {
    type: String,
    required: false,
    default: undefined,
  },
  /**
   * Override the icon name on small screens.
   *
   * @type {String}
   * @default undefined
   */
  nameSm: {
    type: String,
    required: false,
    default: undefined,
  },
  /**
   * Raw SVG markup. When provided, takes precedence over `name`. Injected via `v-html`, so it must be trusted or pre-sanitized.
   *
   * @type {String}
   * @default undefined
   */
  svg: {
    type: String,
    required: false,
    default: undefined,
  },
  /**
   * URL of an SVG to fetch. When provided, takes precedence over `name`. The fetched SVG is injected via `v-html`, so point this at trusted sources only.
   *
   * @type {String}
   * @default undefined
   */
  url: {
    type: String,
    default: undefined,
  },
  /**
   * Fill colour for the glyph. When set, overrides the default sourced from `--sp-comp-icon-fill`.
   *
   * @type {String}
   * @default undefined
   */
  fillColor: {
    type: String,
    default: undefined,
  },
  /**
   * Override the fill colour on small screens.
   *
   * @type {String}
   * @default undefined
   */
  fillColorSm: {
    type: String,
    default: undefined,
  },
  /**
   * Override the default icons-manifest URL. Normally configured app-wide via createSparkleElements({ defaults: { SpIcon: { iconsUrl } } }).
   *
   * @type {String}
   * @default undefined
   */
  iconsUrl: {
    type: String,
    external: true,
    default: undefined,
  },
  /**
   * SVG viewBox attribute used when rendering raw SVG via the `svg` or `url` props.
   *
   * @type {String}
   * @default "0 0 32 32"
   */
  viewBox: {
    type: String,
    default: "0 0 32 32",
  },
});
